import { AutoComplete } from "antd";

const styles = (theme) => ({
    errorwrap: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        fontSize: '0.7rem',
        justifyContent: 'space-between',
        width: '100%',
        background: 'white',
        padding: '100px',
        borderRadius: '5px',
        textAlign: 'center',
        height: "300px",
        color: "red"
    },
    wrap: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    section1: {
        width: '26%'
    },
    section2: {
        width: '72%'
    },
    orderHistory: {
        marginTop: '20px'
    },
    heading: {
        padding: '20px 0 0px 15px',
        background: 'white',
        fontWeight: 'bold',
        fontSize: '14px'
    },
    profile: {
        width: '100px',
        height: '100px',
        border: '1px solid #f58634',
        marginBottom: '20px'
    },
    cardContent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'column'
    },
    statistics: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        marginTop: '20px'
    },
    profileDetails: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: '20px'
    },
    item1: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: '15px'
    },
    item: {
        width: '48%',
        background: '#edf0f4',
        padding: '10px',
        marginTop: '10px'
    },
    label: {
        color: 'lightgrey'
    },
    inputRoot: {
        border: '1px solid grey',
        borderRadius: '20px',
        padding: '10px 15px',
        margin: '10px 0',
        background: 'none',
        '&:focus': {
            borderRadius: '20px',
            background: 'none',
        },
        padding: '10px',
    },
    button: {
        background: '#f58634',
        width: "91px",
        color: 'white',
        borderRadius: '20px',
        padding: '9px 16px',
        textTransform: 'capitalize',
        '&:hover': {
            background: '#f58634'
        },
        marginTop: '7px',

    },

});

export default styles;
